import { render } from "./WizardHistory.vue?vue&type=template&id=45f7a454&scoped=true&ts=true"
import script from "./WizardHistory.vue?vue&type=script&lang=ts"
export * from "./WizardHistory.vue?vue&type=script&lang=ts"

import "./WizardHistory.vue?vue&type=style&index=0&id=45f7a454&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f7a454"]])

export default __exports__